<template>
  <form @submit.prevent="save" novalidate autocomplete="off">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Link to a Q&amp;A</p>
      </header>
      <!-- min-height leaves room for the suggestion dropdown (~200px), which
           renders inside the card: Buefy's append-to-body positions the list
           with window.scrollY, which is wrong inside a fixed modal. -->
      <section class="modal-card-body" style="min-height:380px">
        <div class="has-background-white-ter rounded-lg pa-md mb-md">
          <p class="is-size-7 has-text-grey">Supplier asked ({{ question.ask_count }}x):</p>
          <p class="has-text-weight-bold">{{ question.question }}</p>
        </div>
        <b-field label="Q&A Entry" :message="'Link the entry that answers this question. The question is marked as answered.'">
          <b-autocomplete
            v-model="search"
            :data="options"
            field="title"
            icon="magnify"
            placeholder="Search questions..."
            clearable
            :loading="loading"
            @typing="searchEntries"
            @select="option => selected = option">
            <template v-slot="props">
              <span>{{ props.option.title }}</span>
              <span v-if="props.option.group" class="has-text-grey is-size-7"> &middot; {{ props.option.group.name }}</span>
              <span v-if="props.option.status === 'draft'" class="has-text-warning is-size-7"> &middot; draft</span>
            </template>
            <template #empty>
              {{ loading ? 'Searching...' : 'No matching questions.' }}
            </template>
          </b-autocomplete>
        </b-field>
        <b-message v-if="selected && selected.status === 'draft'" type="is-warning" size="is-small">
          This entry is still a draft — suppliers won't see it until it's switched to Live.
        </b-message>
      </section>
      <footer class="modal-card-foot" style="justify-content:flex-end">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button native-type="submit" type="is-primary" :loading="saving" :disabled="selected === null || saving">Link Entry</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api']),
    endpoint () {
      return this.api.baseUrl + '/v1/assistant/missed-questions/' + this.question.id + '/'
    }
  },
  data () {
    return {
      search: '',
      selected: null,
      options: [],
      loading: false,
      timer: null,
      saving: false
    }
  },
  methods: {
    searchEntries (text) {
      clearTimeout(this.timer)
      this.selected = null
      const query = String(text || '').trim()
      if (query.length < 2) {
        this.options = []
        return
      }
      this.loading = true
      this.timer = setTimeout(() => {
        this.$http.get(this.api.baseUrl + '/v1/assistant/entries/', { params: { search: query, limit: 10, order_by: 'title' } }).then(response => {
          this.options = response.data.results
        }).finally(() => {
          this.loading = false
        })
      }, 250)
    },
    save () {
      if (this.selected === null) return
      this.saving = true
      this.$http.patch(this.endpoint, { entry_id: this.selected.id, status: 'answered' }).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Question linked!' })
        this.$emit('updated')
        this.$parent.close()
      }).catch(() => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'The question could not be linked.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  }
}
</script>
